var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content vessel-native" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("SeaExport.ShippingSchedule"),
                  name: "tabShipppingSchedule",
                  lazy: true
                }
              },
              [_c("tab-shippping-schedule", { ref: "tabShipppingSchedule" })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("SeaExport.Voyage"),
                  name: "tabVoyage",
                  lazy: true
                }
              },
              [_c("tab-voyage", { ref: "tabVoyage" })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("SeaExport.Vessel"),
                  name: "tabVessel",
                  lazy: true
                }
              },
              [_c("tab-vessel", { ref: "tabVessel" })],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }